import { useState } from 'react';
import { Modal } from '../common';

interface CreatePlatformAdminModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (payload: { email: string; name?: string }) => void;
  isSubmitting: boolean;
}

export function CreatePlatformAdminModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
}: CreatePlatformAdminModalProps) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleClose = () => {
    setEmail('');
    setName('');
    setError(null);
    onClose();
  };

  const handleSubmit = () => {
    if (!email.trim()) {
      setError('Email is required');
      return;
    }
    setError(null);
    onSubmit({ email: email.trim(), name: name.trim() || undefined });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Add Platform Admin"
      footer={
        <>
          <button
            onClick={handleClose}
            disabled={isSubmitting}
            className="flex-1 px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-xl font-medium transition-all disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="flex-1 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-medium transition-all disabled:opacity-50"
          >
            {isSubmitting ? 'Adding...' : 'Add Admin'}
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="teammate@resolveai.com"
            className="w-full px-4 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 transition-all"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Jane Doe"
            className="w-full px-4 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 transition-all"
          />
        </div>

        {error && <p className="text-sm text-red-600 dark:text-red-400">{error}</p>}

        <p className="text-sm text-gray-500 dark:text-gray-400">
          They can sign in with a magic link at this email as soon as they&apos;re added — no invite email
          is sent.
        </p>
      </div>
    </Modal>
  );
}
